import spriteUrl from 'lucide-static/sprite.svg?url';

/**
 * URL self-hosted спрайта Lucide (lucide-static 0.460.0 — та сама версія, що в прототипі v4): Vite віддає його окремим
 * хешованим файлом, тож основний бандл не росте від ~1 500 іконок, а браузер вантажить спрайт один раз і кешує.
 */
export const ICON_SPRITE_URL: string = spriteUrl;
